import { useMemo } from "react";
import { useParams } from "react-router-dom";

import DetailViewLoading from "common/components/DetailViewLoading";
import { ArableFieldDetails } from "features/arableFieldDetail";
import {
  FIELD_TYPE,
  useArableField,
  useArableFields,
  useField,
  useFields,
} from "model";
import FieldDetails from "./FieldDetails";

export default function FieldView() {
  const { fieldId } = useParams<{ fieldId: string }>();

  // Get all fields to determine field type
  const { data: allFields = [] } = useFields();
  const { data: allArableFields = [] } = useArableFields();

  // Determine field type by checking which list contains the fieldId
  const fieldType = useMemo(() => {
    if (!fieldId) return undefined;
    const isGrassField = allFields.some((field) => field.guid === fieldId);
    if (isGrassField) return FIELD_TYPE.GRASS;
    const isArableField = allArableFields.some(
      (field) => field.guid === fieldId
    );
    if (isArableField) return FIELD_TYPE.ARABLE;
    return undefined;
  }, [fieldId, allFields, allArableFields]);

  // Use React Query to fetch field data - conditionally based on field type
  const { data: currentField } = useField(
    fieldType === FIELD_TYPE.GRASS ? fieldId : undefined
  );
  const { data: currentArableField } = useArableField(
    fieldType === FIELD_TYPE.ARABLE ? fieldId : undefined
  );

  return currentField ? (
    <FieldDetails field={currentField} />
  ) : currentArableField ? (
    <ArableFieldDetails field={currentArableField} />
  ) : (
    <DetailViewLoading />
  );
}
